import { render, staticRenderFns } from "./SlidePage3.vue?vue&type=template&id=e2bb376e&"
import script from "./SlidePage3.vue?vue&type=script&lang=ts&"
export * from "./SlidePage3.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports